import React from 'react';
import { Video } from '../styled/video';

interface IProps {
  mediaBlob: Blob;
}

export const Playback: React.FC<IProps> = ({ mediaBlob }) => (
  <Video
    controls
    src={URL.createObjectURL(mediaBlob)}
    width="100%"
    height="100%"
  />
);
